import { render } from "./fourthSection.vue?vue&type=template&id=3623bc4a"
import script from "./fourthSection.vue?vue&type=script&lang=js"
export * from "./fourthSection.vue?vue&type=script&lang=js"

import "./fourthSection.vue?vue&type=style&index=0&id=3623bc4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__